import { CacheStore } from 'helpers/CachePool/CachePool';

const KEY_PREFIX = 'cache-store';

export class StorageCacheStore implements CacheStore {
  constructor(
    private readonly prefix = KEY_PREFIX,
    private readonly storage: Storage = localStorage,
  ) {
  }

  private resolveKey(key: string) {
    return `${this.prefix}-${key}`;
  }

  deleteValue(key: string): Promise<void> {
    this.storage.removeItem(this.resolveKey(key));

    return Promise.reject();
  }

  async getValue<T>(key: string): Promise<{ value: T } | undefined> {
    const cachedItem = this.storage.getItem(this.resolveKey(key));
    if (!cachedItem) {
      return undefined;
    }

    try {
      const parsed = JSON.parse(cachedItem);

      if ((parsed.expiresAt > Date.now() || !parsed.expiresAt) && parsed.value !== undefined) {
        return { value: parsed.value as T };
      }

      console.log(`Value for key ${key} expired`);
    } catch (e) {
      console.error(`Error when parsing value from storage for key ${key}`);
      console.error(e);
    }

    await this.deleteValue(key);

    return undefined;
  }

  setValue<T>(key: string, value: T, ttlSeconds?: number): Promise<void> {
    const valueToSave = {
      value,
      expiresAt: ttlSeconds ? Date.now() + ttlSeconds * 1000 : undefined,
    };

    this.storage.setItem(this.resolveKey(key), JSON.stringify(valueToSave));

    return Promise.resolve();
  }
}
